import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from '../AlertDialog'
import * as FA from 'react-icons/fa'
import { DateTime } from 'luxon'

import {
  Container,
  TextContainer,
  Label,
  InfoText,
  MoneyTextMask,
  SmallButton
} from './styles'

export default function Expense ({
  data: expense,
  enableEdit,
  onDelete: handleDelete
}) {
  const [showAlertDialog, setShowAlertDialog] = useState (false)
  const token = AuthService.getToken ()
  
  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const deleteExpense = async () => {
    try {
      await cutileiApi.delete (`/expenses/${expense.id}`, requestConfig)
      handleDelete (expense)
    } catch (error) {
      logApiError (error)
    }
  }

  const toggleAlertDialog = () => setShowAlertDialog (!showAlertDialog)

  return (
    <Container key={expense.id}>
      <Label>
        ({DateTime.fromISO (expense.created_at).toFormat ('HH:mm')})
      </Label>
      <TextContainer>
        <InfoText>{expense.description}</InfoText>
      </TextContainer>
      <MoneyTextMask value={expense.value * -1}/>
      {enableEdit && (
        <SmallButton onClick={toggleAlertDialog}>
          <FA.FaTrash color='#FF3939' size={12}/>
        </SmallButton>
      )}
      {enableEdit && (
        <AlertDialog
          visible={showAlertDialog}
          title='Atenção!'
          message='Deseja realmente excluir esta sangria?'
          confirmText='Sim'
          cancelText='Não'
          onConfirm={deleteExpense}
          onClose={toggleAlertDialog}
          dangerous={true}
        />
      )}
    </Container>
  )
}
